import { render, staticRenderFns } from "./AccountFilters.vue?vue&type=template&id=b54a5c40&"
import script from "./AccountFilters.vue?vue&type=script&lang=js&"
export * from "./AccountFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b54a5c40')) {
      api.createRecord('b54a5c40', component.options)
    } else {
      api.reload('b54a5c40', component.options)
    }
    module.hot.accept("./AccountFilters.vue?vue&type=template&id=b54a5c40&", function () {
      api.rerender('b54a5c40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/filters/AccountFilters.vue"
export default component.exports